import type { FaireProductEntity } from "../../entity_types/product";

export const p_ddxnpth593: FaireProductEntity = {
  token: "p_ddxnpth593",
  type: "product",
  name: "Rocky Lil Dog - Organic Sherpa Knit Stuffed Animal Baby Toy",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/c0113bb73287250c5e7180448e676b9555ed2ceea6a72259d9fd2757ac101a00.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27604ba039959f1a783fc1ce714294cbc914ced479e7489ea5267b89496c5d23.jpeg",
    "https://cdn.faire.com/fastly/e194fdbfd20c68c1afa6f0f607a7ffa7432cb15e3f9e4ecedf5a717ca6974b70.jpeg",
    "https://cdn.faire.com/fastly/51adb05e0cb6c428a5664b60e367b4017558d9ccf6925fc0e952b41212684fdd.jpeg",
    "https://cdn.faire.com/fastly/03f0fcd5fa4f8743267ee905dddf9b86474c1f5befb72c2f8ba0e4dc0b381781.jpeg",
    "https://cdn.faire.com/fastly/ba11b8005ab86b09d792144b90123ba47b72ff057c42d7527e11abdea2f5d9bb.jpeg",
    "https://cdn.faire.com/fastly/97c9cf8cb6503f9d04e7cd62c4bf945f1b5049c45090509b8137dcabe25dd0a7.jpeg",
  ],
  priceDollars: 20,
  description:
    'Organic cotton sherpa knitted Rocky Lil Dog animal stuffed toys, soft and cuddly, comforting and soothing for your little ones.\nSize: Approx 11" Tall\n100% organic cotton outer shell, and poly-fill on the inside.\n\nVIVERANO ORGANIC TOYS:\nQuirky & cuddly collection of organic cotton knit toys for your precious little ones.\nFresh & imaginative designs to bring joy and wonder to babies, kids and even adults.\nGreat for buddy adventures, good company and bedtime snuggles.\nLovingly made by hand using certified organic cotton, safe for hugging & snuggling.\nHeirloom quality, meticulous construction and attention to detail.\nNon-toxic and eco-friendly materials.\nSlight color variations & imperfections may exist making each handmade piece charming and one-of-a-kind.\nEasy care machine washable with cool water and non-toxic detergent, fluff in the dryer for a few minutes and then air dry.\nEthically handcrafted by artisans at a GOTS certified facility in India.',
  tags: [],
  msrpDollars: 40,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:26.732Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
